import { useEffect, useState } from 'react'
import { PlanStatus } from '../models'
import { axiosInstance } from '../helpers'
import { useUser } from './useUser'

export const useVendorPlan = (): {
    plan: PlanStatus | null
    loading: boolean
} => {
    const { workspaceUser } = useUser()
    const [plan, setPlan] = useState<PlanStatus | null>(null)
    const [loading, setLoading] = useState(true)

    const workspaceId = workspaceUser?.active_workspace?.id
    const isVendor = workspaceUser?.active_workspace?.company_type === 'VENDOR'

    useEffect(() => {
        if (!isVendor || !workspaceId) {
            setLoading(false)
            setPlan(null)
            return
        }
        setLoading(true)
        axiosInstance
            .get(`company/vendor/${workspaceId}`)
            .then((res) => {
                setPlan(res.data.plan ?? null)
            })
            .catch(() => setPlan(null))
            .finally(() => setLoading(false))
    }, [isVendor, workspaceId])

    return { plan, loading }
}
